module.exports = __webpack_public_path__ + "img/chapter-2-thumb.4e2259bc.jpg";